import { Avatar as MuiAvatar } from '@mui/material';
import { styled } from '@mui/system';
import { SIDE_NAV_WIDTH, TOP_NAV_HEIGHT } from 'src/constants';

export const TopBarWrapper = styled('div')`
  position: fixed;
  top: 0;
  left: ${SIDE_NAV_WIDTH}px;
  right: 0;
  height: ${TOP_NAV_HEIGHT}px;
  background-color: rgba(249, 249, 252, 1);
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 998;
`;

export const Avatar = styled(MuiAvatar)`
  width: 32px;
  height: 32px;
  margin-right: 16px;
`;
